/**
 * @desc loadClientByClientId
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.ClientDto>;
export function request(body: defs.appCenter.Client, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/load/client`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
